import { render, staticRenderFns } from "./attr.vue?vue&type=template&id=e5ff3e48&scoped=true"
import script from "./attr.vue?vue&type=script&lang=js"
export * from "./attr.vue?vue&type=script&lang=js"
import style0 from "./attr.vue?vue&type=style&index=0&id=e5ff3e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ff3e48",
  null
  
)

export default component.exports